$('.js-aside-dropdown').on('click', function() {
	const MOBILE_MAX_WIDTH = 767;
	const $this = $(this);

	if(window.innerWidth > MOBILE_MAX_WIDTH || !$this.length) {
		console.log('here')
		return;
	}

	$this.toggleClass('is-visible').find('ul').slideToggle();
})